<template>
	<v-btn 
		:href="href"
		target="_blank"
		:title="title"
		v-bind="$attrs"
	>
		<slot>{{ config.facebook }}</slot>
	</v-btn>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	data:() => ({
		href: null,
		title: null
	}),
	computed: {
		...mapGetters(['config'])
	},
	mounted() {
		this.href=`https://www.facebook.com/${this.config.facebook}`
		this.title = this.$attrs.title || `ติดตาม ${this.config.company} บนเฟสบุ๊ค`
	}
}

</script>
